import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { ChangeMobileFormat,ChangeMobileNumber,checkEmailString } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const SubAdminDetail = ({varShowDetail,setShowDetail,varSubAdminIndex,GetSubAdminList}) => {
  const newPwdRef = useRef();
  const chkEmailRef = useRef();
  const chkIDRef = useRef();
  
  //부운영자정보
  const [varSubAdminInfo,setSubAdminInfo] = useState({});
  const [varAvailableArray,setAvailableArray] = useState([]);

  //부운영자정보 읽어오기
  const GetSubAdminInformation = async () => {
    const sendData = {adm_idx:varSubAdminIndex};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_subadmin_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          dataInfo.adm_pwd = "";
          setSubAdminInfo(dataInfo);
          let menuAvailables = dataInfo.adm_available.split(',');
          console.log(menuAvailables);
          setAvailableArray(menuAvailables);
        }
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    //부운영자 정보
    if(varSubAdminIndex === 0){
      const adminState = {adm_idx:0,adm_id:"",adm_name:"",adm_mobile:"",adm_email:"",adm_pwd:"",adm_pwd2:"",adm_available:'1,1,1,1,1,1,1,1,1',old_id:"",old_email:"",chk_id:0,chk_email:0};
      setSubAdminInfo(adminState);
      let menuAvailables = adminState.adm_available.split(',');
      console.log(menuAvailables);
      setAvailableArray(menuAvailables);
    } else {
      GetSubAdminInformation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varSubAdminIndex]);

  //정보입력
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "adm_mobile") {
      setSubAdminInfo({...varSubAdminInfo,adm_mobile:ChangeMobileNumber(value)});
    } else if(name === "adm_id") {
      const btnBox1 = chkIDRef.current;
      if(value === "") {
        if(!btnBox1.classList.contains('gray')) btnBox1.classList.add('gray');
        setSubAdminInfo({...varSubAdminInfo,adm_id:value,chk_id:0});
      } else if(varSubAdminInfo.chk_id === 1 || btnBox1.classList.contains('gray')) {
        if(btnBox1.classList.contains('gray')) btnBox1.classList.remove('gray');
        setSubAdminInfo({...varSubAdminInfo,adm_id:value,chk_id:0});
      } else {
        if(varSubAdminInfo.old_id !== "" && varSubAdminInfo.old_id === value) {
          if(!btnBox1.classList.contains('gray')) btnBox1.classList.add('gray');
          setSubAdminInfo({...varSubAdminInfo,adm_id:value,chk_id:1});
        } else {
          setSubAdminInfo({...varSubAdminInfo,adm_id:value});
        }
      }
    } else if(name === "adm_email") {
      const btnBox1 = chkEmailRef.current;
      if(value === "") {
        if(!btnBox1.classList.contains('gray')) btnBox1.classList.add('gray');
        setSubAdminInfo({...varSubAdminInfo,adm_email:value,chk_email:0});
      } else if(varSubAdminInfo.chk_email === 1 || btnBox1.classList.contains('gray')) {
        if(btnBox1.classList.contains('gray')) btnBox1.classList.remove('gray');
        setSubAdminInfo({...varSubAdminInfo,adm_email:value,chk_email:0});
      } else {
        if(varSubAdminInfo.old_email !== "" && varSubAdminInfo.old_email === value) {
          if(!btnBox1.classList.contains('gray')) btnBox1.classList.add('gray');
          setSubAdminInfo({...varSubAdminInfo,adm_email:value,chk_email:1});
        } else {
          setSubAdminInfo({...varSubAdminInfo,adm_email:value});
        }
      }
    } else if(name === "adm_pwd") {
      const btnBox2 = newPwdRef.current;
      console.log(btnBox2);
      if(value === "") {
        btnBox2.style.display = "none";
      } else {
        btnBox2.style.display = "";
      }
      setSubAdminInfo({...varSubAdminInfo,[name]:value});
    } else {
      setSubAdminInfo({...varSubAdminInfo,[name]:value});
    }
  }

  //부운영자 저장
  const onUpdateSubAdminHandler = async (e) => {
    if(varSubAdminIndex === 0) {
      if(varSubAdminInfo.adm_id === "") {
        alert('부운영자의 ID를 먼저 입력하세요.'); return false;
      } else if(varSubAdminInfo.chk_id === 0) {
        alert('ID 중복검사를 먼저 실행하세요.'); return false;
      } else if(varSubAdminInfo.adm_name === "") {
        alert('부운영자명을 먼저 입력하세요.'); return false;
      } else if(varSubAdminInfo.adm_mobile) {
        alert('부운영자의 연락처를 먼저 입력하세요'); return false;
      } else if(varSubAdminInfo.adm_email === '') {
        alert('이메일을 먼저 입력하세요'); return false;
      } else if(varSubAdminInfo.chk_email === 0) {
        alert('이메일 중복검사를 먼저 실행하세요.'); return false;
      } else if(varSubAdminInfo.adm_pwd !== "") {
        if(varSubAdminInfo.adm_pwd2 === "") {
          alert('확인을 위한 비밀번호 먼저 입력하세요.'); return false;
        } else if(varSubAdminInfo.adm_pwd !== varSubAdminInfo.adm_pwd2) {
          alert('새 비밀번호와 확인 비밀번호가 다릅니다. 다시 입력하세요.'); return false;
        }
      }
    }

    if(!window.confirm('부운영자 정보를 저장합니까?')) return false;

    let copyData = {...varSubAdminInfo};
    let availableData = varAvailableArray.join(',');
    copyData.adm_available = availableData;

    const sendData = {adminInfo:copyData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_subadmin_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        setShowDetail(false);
        GetSubAdminList();
      }
    });
  }
  //중복검사
  const onDuplicationHandler = async(e,imode) => {
    e.preventDefault();
    let btnBox1 = chkEmailRef.current;
    let fieldName = "";
    let fieldValue = "";
    if(imode === 0) {
      btnBox1 = chkIDRef.current;
      if(varSubAdminInfo.adm_id === "") {
        alert('아이디(이메일)을 먼저 입력하세요.'); return false;
      }
      fieldName = 'adm_id';
      fieldValue = varSubAdminInfo.adm_id;
    } else {
      if(varSubAdminInfo.adm_email === "") {
        alert('아이디(이메일)을 먼저 입력하세요.'); return false;
      } 
      if(!checkEmailString(varSubAdminInfo.adm_email)) {
        setSubAdminInfo({...varSubAdminInfo,adm_email:"",chk_email:0});
        alert('아이디(이메일)의 입력값이 이메일 형식에 맞지 않습니다. 확인후 재입력하세요.');
        return false;
      }  
      fieldName = 'adm_email';
      fieldValue = varSubAdminInfo.adm_email;
    }


    const sendData = {adm_idx:varSubAdminIndex,fieldName:fieldName,fieldValue:fieldValue};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_check_duplicate_admin`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(imode === 0) setSubAdminInfo({...varSubAdminInfo,chk_id:1});
        else setSubAdminInfo({...varSubAdminInfo,chk_email:1});
      } else {
        if(imode === 0) {
          if(!btnBox1.classList.contains('gray')) btnBox1.classList.add('gray');
          setSubAdminInfo({...varSubAdminInfo,adm_id:"",chk_id:0});
        } else {
          if(!btnBox1.classList.contains('gray')) btnBox1.classList.add('gray');
          setSubAdminInfo({...varSubAdminInfo,adm_email:"",chk_email:0});
        }
      }
      alert(datas.message);
    });
  }

  //권한설정
  const onSelectMenuHandler = (e,ino) => {
    const iselected = Number(e.currentTarget.checked);
    let copyList = [...varAvailableArray];
    copyList[ino] = iselected;
    setAvailableArray(copyList);
    console.log(iselected,copyList);
  }

  return (
    <div className="admin-content"style={varShowDetail?{display:""}:{display:"none"}}>
      <div className="main-box">
        <table cellPadding="5" cellSpacing="0" border="1" className="write">
          <colgroup><col width="30%"/><col width="70%"/></colgroup>
          <thead></thead>
          <tbody>
            <tr>
              <th>아이디</th>
              <td>{varSubAdminInfo.adm_idx > 0? varSubAdminInfo.adm_id
                  :<>
                    <input type="text" className="w_s_input" name="adm_id" style={{width:"70%"}} value={varSubAdminInfo.adm_id||""} onChange={(e)=>onChangeInputHandler(e)}/>
                    <button  className={varSubAdminInfo.chk_id===0?"btn":"btn gray"} ref={chkIDRef} onClick={e=>onDuplicationHandler(e,0)}>중복확인</button>
                  </>}
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td><input type="text" className="w_s_input" name="adm_name" value={varSubAdminInfo.adm_name||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr>
              <th>연락처</th>
              <td><input type="text" className="w_s_input" style={{width:"50%"}} name="adm_mobile" value={ChangeMobileFormat(varSubAdminInfo.adm_mobile)||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr>
              <th>이메일</th>
              <td>
                <input type="text" className="w_s_input" style={{width:"70%"}} name="adm_email" value={varSubAdminInfo.adm_email||""} onChange={(e)=>onChangeInputHandler(e)}/>
                <button  className={varSubAdminInfo.chk_email===0?"btn":"btn gray"} ref={chkEmailRef} onClick={e=>onDuplicationHandler(e,1)}>중복확인</button>
              </td>
            </tr>
            <tr>
              <th>비밀번호</th>
              <td><input type="password" className="w_s_input" name="adm_pwd" style={{width:"40%"}} value={varSubAdminInfo.adm_pwd||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr ref={newPwdRef} style={{display:"none"}}>
              <th>새 비밀번호 확인</th>
              <td><input type="password" className="w_s_input" name="adm_pwd2" style={{width:"40%"}} value={varSubAdminInfo.adm_pwd2||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            {varAvailableArray.length === 0?null:
              <tr>
                <th>권한설정</th>
                <td>
                  <input type="checkbox" id="adm_available0" checked={Number(varAvailableArray[0])} onChange={e=>onSelectMenuHandler(e,0)}/>
                  <label htmlFor="adm_available0">센터관리</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available1" checked={Number(varAvailableArray[1])} onChange={e=>onSelectMenuHandler(e,1)}/>
                  <label htmlFor="adm_available1">수강관리</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available2" checked={Number(varAvailableArray[2])} onChange={e=>onSelectMenuHandler(e,2)}/>
                  <label htmlFor="adm_available2">학부모/원생관리</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available3" checked={Number(varAvailableArray[3])} onChange={e=>onSelectMenuHandler(e,3)}/>
                  <label htmlFor="adm_available3">발달분석 및 평가</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available4" checked={Number(varAvailableArray[4])} onChange={e=>onSelectMenuHandler(e,4)}/>
                  <label htmlFor="adm_available4">수료증관리</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available5" checked={Number(varAvailableArray[5])} onChange={e=>onSelectMenuHandler(e,5)}/>
                  <label htmlFor="adm_available5">결제관리</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available6" checked={Number(varAvailableArray[6])} onChange={e=>onSelectMenuHandler(e,6)}/>
                  <label htmlFor="adm_available6">매출리포트</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available7" checked={Number(varAvailableArray[7])} onChange={e=>onSelectMenuHandler(e,7)}/>
                  <label htmlFor="adm_available7">정산현황</label>&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="adm_available8" checked={Number(varAvailableArray[8])} onChange={e=>onSelectMenuHandler(e,8)}/>
                  <label htmlFor="adm_available8">설정</label>&nbsp;&nbsp;&nbsp;
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div className="btn-center" style={{marginBottom:"20px"}}>
        <button onClick={(e)=>onUpdateSubAdminHandler(e)} style={{width:"90px"}} className="btn">저장</button>
        <button onClick={()=>setShowDetail(false)} style={{width:"90px"}} className="btn line">닫기</button>
      </div>
    </div>
  );
}
export default SubAdminDetail;